<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M6 3v26h20V9.6l-.3-.3-6-6-.3-.3Zm2 2h10v6h6v16H8Zm12 1.4L22.6 9H20Z"
    />
  </svg>
</template>
